import { NgModule } from '@angular/core';
import { ExLibComponent } from './ex-lib.component';

@NgModule({
  declarations: [ExLibComponent],
  imports: [
  ],
  exports: [ExLibComponent]
})
export class ExLibModule { }
